import React from "react";
import { getIconCSSClass } from "../../utils/index";

export default function ExternalLinkMobile({
  id,
  createNonInternalStream,
  linkExternal,
  title,
  tabindex,
  children,
}) {
  return (
    <a
      id={`action-point-${id}`}
      onClick={() => createNonInternalStream()}
      title={title}
      href={linkExternal}
      target="_blank"
      tabindex={tabindex}
    >
      {children}
    </a>
  );
}
